import { render, staticRenderFns } from "./Partner.vue?vue&type=template&id=bdbf185c&scoped=true&"
var script = {}
import style0 from "./Partner.vue?vue&type=style&index=0&id=bdbf185c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdbf185c",
  null
  
)

export default component.exports